import CSS from 'csstype';
import React from 'react';

import { ISvgIconProps } from '~/src/dash/components/icons/common';
import { CaretMiniDownIcon, CaretMiniUpIcon } from '~/src/dash/components/icons/misc-icons';
import { FONT_WEIGHT, fontSizing } from '~/src/dash/components/text/common';
import { Col, Cols } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

interface IMenuToggleProps {
  isActive: boolean;
  className?: string;
  disabled?: boolean;
  onClick: (props?: any | null) => void;
  style?: CSS.Properties;
  value?: string;
  SvgIcon?: (props: ISvgIconProps) => JSX.Element;
  iconStyle?: CSS.Properties;
  children?: any; // this will override value
}

// TODO: V2 WE WILL ADD DYNAMIC THEME COLOR SWITCHING. FOR NOW THIS FORCES THE PUBLICA COLOR THEME.
export const MenuToggle = ({
  isActive,
  className = '',
  disabled,
  onClick,
  style,
  value,
  SvgIcon,
  iconStyle = {},
  children,
}: IMenuToggleProps) => {
  // const { theme } = usePanel();

  return (
    <button
      onClick={disabled ? () => null : onClick}
      className={className}
      style={{
        display: 'inline-block',
        borderWidth: 0,
        lineHeight: 'inherit',
        fontFamily: 'inherit',
        fontStyle: 'inherit',
        whiteSpace: 'nowrap',
        margin: 0,
        backgroundColor: isActive ? publicaColors.white : 'inherit',
        color: isActive ? publicaColors.black : publicaColors.darkGray,
        opacity: disabled ? 0.4 : 1,
        cursor: disabled ? 'not-allowed' : 'pointer',
        minWidth: '40px',
        textAlign: 'center',
        fontSize: fontSizing.small,
        fontWeight: FONT_WEIGHT.bold,
        borderRadius: '5px',
        border: `1px solid ${publicaColors.lightGray}`,
        padding: '3px 8px',
        ...style,
      }}
    >
      <Cols style={{ alignItems: 'center', flexWrap: 'nowrap' }}>
        {SvgIcon && (
          <SvgIcon
            color={isActive ? publicaColors.black : publicaColors.veryDarkGray}
            style={{ height: '12px', ...iconStyle }}
          />
        )}
        <Col smallHorizontalPadding>{children || value}</Col>
        <Col displayFlex extraSmallHorizontalPadding>
          {isActive ? (
            <CaretMiniUpIcon color={isActive ? publicaColors.black : publicaColors.veryDarkGray} />
          ) : (
            <CaretMiniDownIcon
              color={isActive ? publicaColors.black : publicaColors.veryDarkGray}
            />
          )}
        </Col>
      </Cols>
    </button>
  );
};
